import { ItemValor } from '../../types/Dashboard';

// Divisões "redondas" do eixo (1, 2, 2,5, 5 x 10^n), sempre incluindo o zero
export function ticksAgradaveis(min: number, max: number, alvo = 4): number[] {
  const lo = Math.min(0, min);
  const hi = Math.max(0, max);
  if (lo === hi) return [0, 1];
  const bruto = (hi - lo) / alvo;
  const potencia = 10 ** Math.floor(Math.log10(bruto));
  const passo = [1, 2, 2.5, 5, 10].map(m => m * potencia).find(p => p >= bruto) ?? bruto;
  const ini = Math.floor(lo / passo) * passo;
  const fim = Math.ceil(hi / passo) * passo;
  const ticks: number[] = [];
  for (let v = ini; v <= fim + passo / 2; v += passo) ticks.push(Math.round(v / passo) * passo);
  return ticks;
}

// Mais de `max` itens: os primeiros max-1 ficam, o resto vira "Outros" (nunca uma 9ª cor)
export function agruparOutros(itens: ItemValor[], max = 8): ItemValor[] {
  if (itens.length <= max) return itens;
  const resto = itens.slice(max - 1).reduce((s, i) => s + i.valor, 0);
  return [...itens.slice(0, max - 1), { rotulo: 'Outros', valor: resto }];
}

// De quantos em quantos pontos cabe um rótulo do eixo X sem colidir
export function passoRotulos(qtd: number, larguraPorItem: number, larguraRotulo = 52) {
  return Math.max(1, Math.ceil(larguraRotulo / Math.max(1, larguraPorItem)));
}
